import { module } from 'modujs';

export default class extends module {
    constructor(m) {
        super(m);

        this.events = {
            submit: 'handleSubmit'
        }
    }

    init() {
        this.urlRedirect = this.getData('url-redirect')
    }

    //TODO : prefill/select options based on url? Ou fait en backend?

    /**
     * Handle sumbit and query parameters
     * ⚠️ Won't work on IE11
     *
     * @param
     */
    handleSubmit(event) {
        event.preventDefault();
        const formData = new FormData(event.target);
        const queryString = new URLSearchParams(formData).toString();
        let url = window.location.href;

        if(this.urlRedirect) {
            url = this.urlRedirect
        }

        this.call('goTo', { url: `${url.split('?')[0]}?${queryString}`, transition: 'light' }, 'Load')
    }
}
